import { call, put, takeLatest } from "redux-saga/effects";
import { showAlert } from "../../alertSlice";
import { pauseWorkflowApi } from "../../../api/apiLists/workflow";
import {
  pauseWorkflowFailure,
  pauseWorkflowRequest,
  pauseWorkflowStart,
  pauseWorkflowSuccess,
  fetchWorkflowListRequest
} from "../../slices/workflow";
import { callWorkflowApi, requireWhatsAppModuleAccess } from "./workflowSagaHelper";

function buildPauseSuccessMessage(data) {
  const parts = [data?.message || "Workflow paused successfully."];
  if (data?.warning) parts.push(data.warning);
  return parts.join(" ");
}

function* handlePauseWorkflow(action) {
  if (!(yield call(requireWhatsAppModuleAccess))) return;

  try {
    yield put(pauseWorkflowStart());

    const req = action.payload || { operation: "PAUSE_WORKFLOW", payload: {} };
    const res = yield callWorkflowApi(pauseWorkflowApi, req);

    if (res?.status) {
      yield put(pauseWorkflowSuccess(res?.data || null));
      yield put(showAlert({
        message: buildPauseSuccessMessage(res?.data),
        type: "success"
      }));
      yield put(fetchWorkflowListRequest({ operation: "LIST_WORKFLOWS", payload: {} }));
      return;
    }

    const errMsg = res?.errMsg || "Failed to pause workflow";
    yield put(pauseWorkflowFailure(errMsg));
    yield put(showAlert({ message: errMsg, type: "error" }));
  } catch (error) {
    const errMsg = error.message || "Failed to pause workflow";
    yield put(pauseWorkflowFailure(errMsg));
    yield put(showAlert({ message: errMsg, type: "error" }));
  }
}

export default function* workflowPauseSaga() {
  yield takeLatest(pauseWorkflowRequest.type, handlePauseWorkflow);
}
